<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner rew19-contents-inner--wide">
      <h2 class="rew19-contents-title">정기구매 History</h2>

      <div class="rew19-search-box rew19-flex-box">
        <div class="rew19-datepicker-wrap">
          <date-picker
            ref="reqStartDate"
            :readOnly="true"
            @update-date="updateReqStartDate" v-once></date-picker>
          <button @click="$refs.reqStartDate.$el.focus();" type="button">달력</button>
        </div>

        <div class="rew19-datepicker-hypn">-</div>

        <div class="rew19-datepicker-wrap">
          <date-picker
            ref="reqEndDate"
            :readOnly="true"
            @update-date="updateReqEndDate" v-once></date-picker>
          <button @click="$refs.reqEndDate.$el.focus();" type="button">달력</button>
        </div>

        <div class="rew19-datepicker-btn">
          <a @click="loadList(1)" class="rew19-btn-normal">검색</a>
        </div>
      </div>

      <div class="rew19_payment_list-total">
        총
        <strong>{{$fmt.PDCnt(viewData.totalHistory)}}</strong>개
      </div>

      <div class="rew19_payment_wrap">
        <table class="rew19-table-col">
          <caption>콜 테이블</caption>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th class="table-col__head">
                정기구매번호
                <span class="rew19_nextLine">(회차)</span>
              </th>
              <th class="table-col__head">수령인</th>
              <th class="table-col__head">주문금액</th>
              <th class="table-col__head">상태</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(history, idx) in viewData.history_list" v-bind:key="idx"
              class="clickRow"
              @click="onClickItem(history)">
              <td class="table-col__data">
                  {{history.aro_no}}({{history.payment_count}})
              </td>
              <td class="table-col__data">{{history.ship_name}}</td>
              <td class="table-col__data">{{$fmt.WON(history.payment_amt)}}원</td>
              <td class="table-col__data">
                <span v-bind:class="paymentStatusClass(history.payment_status)">{{history.payment_status}}</span>
                <span v-if="showButtonBox(history)" class="rew19_nextLine">
                    <a href="#"
                      v-if="history.cancel_yn == 'Y'"
                      class="rew19_btn_intable"
                      @click.stop.prevent="onClickOrderCancel(history)">주문취소</a>
                    <a href="#"
                      v-if="history.payment_check == 'N'"
                      class="rew19_btn_intable active"
                     @click.stop.prevent="onClickRepayment(history)">재결제</a>
                </span>
              </td>
            </tr>
            <tr v-if="!viewData.history_list || viewData.history_list.length <= 0">
              <td colspan="4" class="table-col__data no_data">정기구매 히스토리 내역이 없습니다.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- TODO : paging 처리 -->
      <page-nav
        ref="pageNav"
        :totalItemCount="1"
        :pageNo="1"
        :itemCountPerPage="10"
        :pageGroup="10"
        @onClickPage="onClickPage"
      ></page-nav>

    </div>
    <!--rew19_contents_inner-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import PageNav from "@/components/paging/pageNav";
import DatePicker from "@/components/control/DatePicker";

import DF from 'dateformat';

export default {
  name: "aroHistoryList",
  extends: AroBase,
  components: { PageNav, DatePicker },
  computed: {
     isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
     }
  },
  props: {
    countPerPage: {
      type: Number,
      default: 10
    }
  },
  data(){
    return{
      //View Data
      viewData : {
        historyList : []
      },
      params : {
        reqStartDate : null,
        reqEndDate : null,
        pageNo : 1
      },
      testText : ""
    }
  },

  created() {

  },
  mounted() {
    let _this = this;

    {
      let endDate = new Date();
      let startDate = new Date();
      startDate.setDate(startDate.getDate()-31);
      _this.params.reqStartDate = DF(startDate, "yyyy.mm.dd");
      _this.$refs.reqStartDate.setDate(_this.params.reqStartDate);
      _this.params.reqEndDate = DF(endDate, "yyyy.mm.dd");
      _this.$refs.reqEndDate.setDate(_this.params.reqEndDate);
    }

    _this.loadList(1);
  },

  methods: {

    paymentStatusClass : function(payment_status) {
      let statusClass = 'rew19_text_black';

      if(payment_status.indexOf('결제실패') > -1)
        statusClass = 'rew19_text_red';

      if(payment_status.indexOf('결제완료') > -1)
        statusClass = 'rew19_text_green';

      return statusClass;
     },

    updateReqStartDate(d) {
      let _this = this;
      _this.params.reqStartDate  = d;
    },

    updateReqEndDate(d) {
      let _this = this;
      _this.params.reqEndDate  = d;
    },

    /**
     * API Request
     */
    //aro history 가져오기
    apiGetAroHistory(reqSDate, reqEDate, pageNo){
      let _this = this;

      var reqStartDate = reqSDate.replace(/\./g, '-');
      var reqEndDate = reqEDate.replace(/\./g, '-');

        return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro_history`, {
          params: {
            startym : reqStartDate,
            endym : reqEndDate,
            page : pageNo,
            countPerPage : 10
          }
        });
    },

    // 재결제
    apiMyAroRepay (member_name, aro_no, payment_target){
      let _this = this;
        return _this.$http.get(`${_this.$aroApiBasePath}/aro/repayment`, {
          params: {
            member_name : member_name,
            aro_no : aro_no,
            payment_target : payment_target
          }
        });
    },

    // 주문 취소
    apiOrderCancel(aro_no, aro_order_no){
        let _this = this;
        return _this.$http.get(`${_this.$aroApiBasePath}/aro/order_cancel`, {
          params: {
            aro_no : aro_no,
            aro_order_no : aro_order_no
          }
        });
    },


    /**
     * Local function
     */
    //데이터 로드
    loadList(pageNo){
      let _this = this;

      // 날짜 검색 validation
      if(_this.params.reqStartDate >  _this.params.reqEndDate){
        _this.$dialogs.alert('날짜를 확인해주세요.');
        return false;
      }

      //init data
      _this.viewData = {
        ..._this.viewData,
        countPerPage : _this.countPerPage,
        page : 1,
        totalHistory : 0,
        history_list : []
      };

      //NetFunnel : 정기구매 History' 진입 및 검색 버튼 클릭시
      NFStart({projectKey: 'service_1', segmentKey: 'act_18'}, function (response) {
        //show loading
        _this.$showLoading();

        _this.apiGetAroHistory(_this.params.reqStartDate, _this.params.reqEndDate, pageNo).then(res=>{

          if (res.status === 200 && res.data.status === "0000") {
            _this.viewData = {...res.data};
          }else{
            //console.error(res);
            _this.$dialogs.alert(res.data.message).then(res => {});
          }

        }).catch(()=>{
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          NFStop();

          //hide loading
          _this.$hideLoading();

          //Pass Paging info
          _this.$refs.pageNav.resetVal(
            _this.viewData.totalHistory,
            _this.viewData.page,
            _this.countPerPage,
          );
        });
      });
    },

    onClickPage(pageNo){
      let _this = this;

      _this.loadList(pageNo);
    },

    onClickItem(item){
      let _this = this;
      _this.$router.push(`${_this.$aroBasePath}/aroHistoryDetail?aro_no=${item.aro_no}&aro_order_no=${item.aro_order_no}`);
    },

    // 버튼 이벤트
    showButtonBox : function(history){
      if(history.cancel_yn == 'Y' || history.payment_check =='N'){
        return true;
      }
      return false;
    },

    // 재결제
    onClickRepayment : function(item){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'확인'};
      _this.$dialogs.confirm("해당 ARO에 대한 재결제를 진행하시겠습니까?<br>(결제 정보를 다시 한번 확인하신 후 재결제를 진행해주세요.)", options).then(res=>{
        if(res.ok){
          _this.doRepayment(item);
        }
      });
    },

    //재결제
    doRepayment(item){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiMyAroRepay(item.ship_name, item.aro_no, item.payment_target).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("처리가 완료 되었습니다.", {okLabel:"확인"})
          .then(res => {});

          _this.loadList(_this.viewData.page);

        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    // 주문취소
    onClickOrderCancel(item){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'확인'};
      _this.$dialogs.confirm("주문취소를 진행하시겠습니까?", options).then(res=>{
        if(res.ok){
          _this.doOrderCancel(item);
        }
      });
    },

    // 주문취소
    doOrderCancel(item){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiOrderCancel(item.aro_no, item.aro_order_no).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("처리가 완료 되었습니다.", {okLabel:"확인"})
          .then(res => {});

          _this.loadList(_this.viewData.page);
        }else{
          //console.error(res);
          _this.$dialogs.alert(res.data.message).then(res => {});
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

  }
}
</script>
<style>
tr.clickRow, a.rew19-btn-normal, a.rew19_btn_intable{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/aro/historyList.vue